/**
 * Public-site URLs for the dashboard "open live site" + "voir en ligne" links. Defaults to the
 * deployed Cloudflare hosts; override per environment via REACT_APP_PREVIEW_SITE_URL /
 * REACT_APP_PRODUCTION_SITE_URL (set to http://localhost:3050 / :3060 in local dev).
 */
const strip = (value: string) => value.replace(/\/+$/, "");

export const PREVIEW_SITE_URL = strip(process.env.REACT_APP_PREVIEW_SITE_URL || "https://apa-parts.preview.pulsarinteractive.io");
export const PRODUCTION_SITE_URL = strip(process.env.REACT_APP_PRODUCTION_SITE_URL || "https://apa-parts.production.pulsarinteractive.io");

/** Pretty host label for a site URL (e.g. "apa-parts.preview.pulsarinteractive.io"). */
export const siteHost = (url: string): string => {
	try {
		return new URL(url).host;
	} catch {
		return url.replace(/^https?:\/\//, "");
	}
};

/** Join a public base URL with a content path (handles leading slashes; empty path → the base). */
export const buildPublicUrl = (base: string, path?: string | null): string => {
	const p = (path ?? "").replace(/^\/+/, "");
	return p ? `${base}/${p}` : base;
};
